import { Component, OnInit } from '@angular/core';
import { LocationService } from 'projects/qcloud-rest-client/src/lib/location.service';
import { AuthService } from 'projects/qcloud-rest-client/src/lib/auth/auth.service';
import { RouteNavigationService } from '../../../shared/route-navigation.service';
import { ChangesTrackerService } from '../../../shared/changes-tracker.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-work-schedule',
  templateUrl: './work-schedule.component.html',
  styleUrls: ['./work-schedule.component.css']
})
export class WorkScheduleComponent implements OnInit {

  constructor(
    private locationService: LocationService,
    private authService: AuthService, 
    public router: RouteNavigationService, 
    private changesTracker: ChangesTrackerService,
    private angularRouter: Router
  ) { }

  ngOnInit(): void {
    this.locationService.getLocationData(this.authService.getLocationId()).subscribe(
      locData => this.locationService.locationData = locData
    );

    const changedEntityType = this.changesTracker.getChangedEntityType();
    if (changedEntityType) {
      setTimeout(() => {
        const element = document.getElementById(changedEntityType);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    }
  }

  checkConstraints(): boolean {
    return this.locationService.getLocationConstraints()?.isWorkersScheduleEnabled;
  }
}
